import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import './scss/styles.scss';
import Modal, { BaseProps } from './Modal';

const queryClient = new QueryClient();

const Index = function Root(props: BaseProps): React.ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <Modal {...props} />
    </QueryClientProvider>
  );
};

export default Index;
